import { DayType } from "./DayType";

export const dayTypeCategories = {
    // Praca
    work: [DayType.P, DayType.Ps, DayType.D, DayType.Prz],

    'off-work': [
      DayType.W,
      DayType.Wo,
      DayType.Pw,
      DayType.Xw,
      DayType.Xb,
      DayType.Xd,
      DayType.Ws,
      DayType.Wn,
      DayType.Wx,
    ],

    vacation: [
      DayType.U,
      DayType.Uz,
      DayType.U2,
      DayType.Uo,
      DayType.Bw,
      DayType.Ui,
      DayType.Un,
      DayType.Ur,
      DayType.Ux,
      DayType.Us,
      DayType.Um,
      DayType.Uf,
      DayType.Bp,
      DayType.D1,
      DayType.D2,
      DayType.C,
      DayType.Cn,
      DayType.Cb,
      DayType.Oo,
      DayType.Od,
      DayType.Os,
      DayType.Or,
      DayType.Rb,
      DayType.Rc,
      DayType.Rw,
      DayType.Z,
      DayType.Zb,
      DayType.Zn,
      DayType.Zs,
      DayType.Zw,
      DayType.Uoj,
      DayType.M,
    ],

    absences: [DayType.Nn, DayType.Np, DayType.Nu],

    allowances: [
      DayType.C,
      DayType.M,
      DayType.Uoj,
      DayType.Z,
      DayType.Zb,
      DayType.Zs,
      DayType.Zw,
      DayType.Zn,
      DayType.Od,
      DayType.Os,
      DayType.Or,
      DayType.Oo,
      DayType.Cn,
      DayType.Cb,
      DayType.Rc,
      DayType.Rw,
      DayType.Rb,
    ],

    other: [DayType.Sw],
  }